/* __next_internal_client_entry_do_not_use__ ChatBubble auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=26%3A1881))
 * @trackcomponent
 * @lastsynced 2023-07-17T14:31:44.690Z
 */ export var ChatBubble = createSVGIcon(/*#__PURE__*/ _jsx("path", {
    d: "M11.9968 0.923082C9.99368 0.923706 8.02829 1.46779 6.3099 2.49739C4.59152 3.52699 3.1845 5.00354 2.23871 6.76978C1.29291 8.53602 0.843759 10.5258 0.939092 12.5272C1.03442 14.5286 1.67067 16.4666 2.78006 18.1349L0.923096 23.0769L7.14138 21.9522C8.63872 22.6841 10.2819 23.0685 11.9484 23.0768C13.615 23.085 15.2619 22.7169 16.7664 21.9999C18.2709 21.2828 19.5942 20.2353 20.6377 18.9355C21.6812 17.6356 22.4179 16.117 22.7929 14.4927C23.1679 12.8684 23.1716 11.1804 22.8037 9.55444C22.4357 7.92852 21.7057 6.40665 20.6679 5.10226C19.6301 3.79787 18.3114 2.74462 16.81 2.02101C15.3086 1.2974 13.6633 0.922098 11.9968 0.923082V0.923082Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), "ChatBubble", {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
